import useCreateApplication from './useCreateApplication';

export default useCreateApplication;
